module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/home-heart-5a66484d21c32cce82daeade3000b5f8.svg";